// lodash
import isString from 'lodash/isString';

export default function checkStringContains(string = '', arr = []) {
  if (!isString(string)) {
    return false;
  }

  let check = false;
  for (let i = 0; i < arr.length; i += 1) {
    const hasString = string.indexOf(arr[i]) !== -1;
    if (!hasString) {
      check = false;
      break;
    }
    check = true;
  }
  return check;
}
